import { scaleToPom } from '@game/util/translatePomPos'

import { HIT_RADIUS } from '@game/constants'

export const models = {
  particle: {
    0 (ctx, x, y, scale, color1, color2, z) {
      ctx.circ(x, y, scale, (color1 - 1) + Math.round((z / 6) * 2))
    }
  },

  vacant: {
    0 (ctx, x, y, scale, color1) {
      ctx.circFillDither(x, y + 1, scaleToPom(2) * scale, color1 - 1, color1)
      ctx.circ(x, y, scaleToPom(4) * scale, color1 - 1)
    }
  },

  selection: {
    1 (ctx, x, y, scale, color1, color2) {
      ctx.circ(x, y + 1, scaleToPom(scale), color2 + 1)
      ctx.circ(x, y, scaleToPom(scale), color1 + 1)
    }
  },

  shadow: {
    0 (ctx, x, y, scale, color1, color2) {
      ctx.circFillDither(x, y, scaleToPom(8) * scale, color2, color1)
      ctx.circFill(x, y, scaleToPom(6) * scale, color1)
      ctx.circFillDither(x, y, scaleToPom(4) * scale, color1, color1 - 1)
      ctx.circFill(x, y, scaleToPom(2) * scale, color1 - 1)
    }
  },

  stem: {
    0 (ctx, x0, y0, scale, color1, color2, actor, z, px, py) {
      const x1 = x0 + actor.x + ((z + 2 * scale) * px)
      const y1 = y0 + actor.y + ((z + 2 * scale) * py)
      ctx.line(x0 - 1, y0, x1, y1, color1 - 1)
      ctx.line(x0, y0, x1, y1, color1 - 1)
      ctx.line(x0, y0 + 1, x1, y1, color1 - 1)
      ctx.line(x0, y0 - 1, x1, y1, color1 - 1)
      ctx.line(x0, y0, x1, y1, color1 - 1)
      ctx.line(x0 + 1, y0, x1, y1, color1 - 1)
    }
  },

  pom: {
    0 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFillDither(x, y, scaleToPom(HIT_RADIUS + 1) * scale, color2, color1 - 2)
    },
    1 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFillDither(x, y, scaleToPom(HIT_RADIUS) * scale, color1 - 2, color1 - 1)
    },
    2 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFillDither(x, y, scaleToPom(HIT_RADIUS - 2) * scale, color1 - 1, color1)
    },
    3 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFillDither(x, y, scaleToPom(HIT_RADIUS - 3) * scale, color1, color1 + 1)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS - 6) * scale, color1 + 1)
    },
    4 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS - 6) * scale, color1 + 1)
    }
  },

  shroom: {
    0 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS) * scale, color1 + 1)
    },
    1 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS) * scale, color1, color1 + 1)
    },
    2 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS - 1) * scale, color1 - 1, color1 + 1)
    },
    3 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFillDither(x, y, scaleToPom(HIT_RADIUS - 2) * scale, color1 - 1, color1)
    },
    4 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS - 4) * scale, color1, color1 + 1)
    },
    5 (ctx, x, y, scale, color1, color2, actor, z, px, py) {
      x += ((z + 2 * scale) * px)
      y += ((z + 2 * scale) * py)
      ctx.circFill(x, y, scaleToPom(HIT_RADIUS - 7) * scale, color1 + 1)
    }
  }
}
